export default __webpack_public_path__ + "img/update.bdcba1f8.webp";